import { createFileRoute } from '@tanstack/react-router';
import { redirectFromWorkstations } from '../../../../utils/workstationGuard';
import { lazy, Suspense } from 'react';
import Loading from '../../../../pages/Loading/Loading';
import { z } from 'zod';

const WorkstationsList = lazy(() => import('../../../../pages/WorkstationsList/WorkstationsList'));

const workstationsSearchSchema = z.object({
  q: z.string().optional().default(''),  // search query for workstation name
  tab: z.enum(['available', 'unavailable', 'history']).optional().default('available'),
});

export type WorkstationsSearch = z.infer<typeof workstationsSearchSchema>;

export const Route = createFileRoute('/$lang/_authenticated/workstations')({
  validateSearch: workstationsSearchSchema,
  beforeLoad: redirectFromWorkstations,
  component: () => (
    <Suspense fallback={<Loading />}>
      <WorkstationsList />
    </Suspense>
  ),
});
